<div class="tw-relative tw-flex tw-h-16 tw-cursor-pointer tw-items-center tw-gap-3 tw-overflow-hidden tw-rounded-[20px] tw-border tw-border-solid tw-border-[color:var(--sys-divider)] tw-pr-2 tw-text-[var(--sys-text)] active:tw-bg-[var(--sys-cashregister-pressed)]"
     [ngClass]="odd ? 'tw-bg-[var(--sys-cashregister-card-alt)]' : 'tw-bg-[var(--sys-card)]'"
     tilbyGestures (click)="itemTapped.emit(item)" (longPress)="itemLongPressed.emit(item)">
    <span class="tw-h-full tw-w-3 tw-shrink-0" [ngStyle]="{ 'background-color': accentColor }"></span>
    <p class="tw-m-0 tw-min-w-[4.5rem] tw-flex-auto tw-overflow-hidden tw-break-words tw-font-medium tw-leading-[1.2] tw-tracking-tight tw-line-clamp-2"
       [style.max-height.em]="2 * 1.2"
       [ngStyle]="{ 'font-size': fontNameSize + 'px' }">{{ item.name }}</p>
    @if (showItemIcon && item.icon) {
        <mat-icon class="tw-h-8 tw-w-8 tw-shrink-0" [svgIcon]="item.icon"></mat-icon>
    }
    @if (showThumbnail) {
        <div class="tw-flex tw-h-[49px] tw-w-[63px] tw-min-w-fit tw-shrink tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-xl tw-bg-[var(--sys-cashregister-media-bg)]">
            @if (item.thumbnail) {
                <img class="tw-pointer-events-none tw-h-full tw-w-full tw-object-cover tw-object-top" [src]="item.thumbnail" alt=""/>
            } @else {
                <span class="tw-text-base">{{ initials }}</span>
            }
        </div>
    }
    <div class="tw-flex tw-max-w-[45%] tw-shrink-0 tw-flex-wrap tw-items-center tw-justify-between tw-gap-x-2 tw-gap-y-0.5" [ngClass]="showThumbnail ? 'tw-min-w-[min(120px,45%)]' : ''">
        <span class="tw-whitespace-nowrap" [ngStyle]="{ 'font-size': fontPriceSize + 'px' }">
            {{ showPrices ? ($any(item[priceIdentifier]) | tilbyCurrency : (priceWithCurrency ? undefined : '')) : '***' }}
        </span>
        @if (getStockStatus(item); as stock) {
            @if (isStockVisible(stock.status)) {
                <app-showcase-stock-badge [status]="stock.status" [quantity]="stock.stock_quantity"/>
            }
        }
    </div>
</div>
